<template>
  <div>
    <h3>Definition</h3>
    <p>
      Small satellites cannot always provide enough power to thrust continuously
      with their propulsion system. Such spacecrafts must usually perform a
      succession of finite burn arcs to manoeuvre.
    </p>
    <p>
      The orbital duty cycle <katex-element expression="\xi" /> represents the
      fraction of an orbit for which the propulsion system is thrusting. By
      default, <katex-element expression="\xi" /> is equal to the ratio between
      the <b>orbital average power</b> available for propulsion and the
      <b>nominal power</b> of the propulsion system.
    </p>
    <h3>Customization</h3>
    <p>
      One can customize the orbital duty cycle
      <katex-element expression="\xi" /> of the propulsion system.
    </p>
    <p>
      If <katex-element expression="\xi" /> is set to 100%, the propulsion
      system thrusts continuously. When set to a lower value, two burns are
      performed on symmetric arcs of the orbit to preserve its circular shape.
      These burn arcs are centered around the orbital nodes to improve the
      efficiency of inclination change manoeuvres (see figure below).
    </p>
    <v-img
      contain
      :src="require('../../assets/images/tooltip-orbital-duty-cycle.png')"
      aspect-ratio="1.25"
    /><br />
    <h3>Trade-off</h3>
    <p>
      Inclination changes are more efficient when the burns are performed closer
      to the orbital nodes. As a consequence:
    </p>
    <ul>
      <li>
        A bigger value of <katex-element expression="\xi" /> will decrease the
        number of burns and the duration of any manoeuvre, but it will increase
        the cumulated thrusting duration and the propellant mass needed for
        manoeuvres that involve inclination changes.
      </li>
      <li>
        On the contrary, a smaller value of
        <katex-element expression="\xi" /> will increase the number of burns and
        the duration of any manoeuvre, but it will decrease the cumulated
        thrusting duration and the propellant mass needed for manoeuvres that
        involve inclination changes.
      </li>
    </ul>

    <v-img
      contain
      :src="require('../../assets/images/duty-cycle-tradeoff.png')"
      aspect-ratio="1.8"
    /><br />
    <h3>Skipping orbits</h3>
    <p>
      If <katex-element expression="\xi" /> is chosen greater than the ratio
      between the orbital average power available for propulsion and the nominal
      power of the propulsion system, some thrust arcs will be periodically
      skipped to preserve the maximum value of the average duty cycle
      achievable.
    </p>
    <p>
      This will very likely increase the manoeuvre duration, but the number of
      burns performed by the propulsion system will decrease.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipDutyCycleAnalytical'
}
</script>
